export default __webpack_public_path__ + "static/media/welcome.87421876.jpg";